export const useAboutUs = async () => useFetchSafely(() => `pages/about-us`);
